export default __webpack_public_path__ + "static/media/logo-bressanidev-dark.b0e3c511.svg";